import { FC, ReactNode, useCallback, useEffect, useState } from 'react'

import { FeedbackEnum } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { FloatingTooltipCard, Tooltip } from '@avantstay/backoffice-core'
import { IconThumbsUp2, IconThumbsUp2Filled } from '@avantstay/backoffice-vectors'

import * as S from './AIElements.styles'
import { getThumbsDownTooltip, getThumbsUpTooltip } from './RateAIResponse.utils'

interface RateAIResponseProps {
  id: string
  aiRatingResponseTooltip?: ReactNode
  initialRating?: FeedbackEnum
  onChangeRating: (id: string, rating: FeedbackEnum, userId?: string) => void
}

export const RateAIResponse: FC<RateAIResponseProps> = ({
  id,
  aiRatingResponseTooltip,
  initialRating,
  onChangeRating,
}) => {
  const [currentRating, setCurrentRating] = useState(initialRating)

  useEffect(() => {
    setCurrentRating(initialRating)
  }, [initialRating])

  const handleRatingChange = useCallback(
    (clickedRating: FeedbackEnum) => {
      const newRating = currentRating === clickedRating ? FeedbackEnum?.undefined : clickedRating

      setCurrentRating(newRating)
      onChangeRating(id, newRating)
    },
    [id, currentRating, onChangeRating],
  )

  const isPositive = currentRating && currentRating === FeedbackEnum?.positive
  const isNegative = currentRating && currentRating === FeedbackEnum?.negative

  const ThumbsUpIcon = isPositive ? IconThumbsUp2Filled : IconThumbsUp2
  const ThumbsDownIcon = isNegative ? IconThumbsUp2Filled : IconThumbsUp2

  return (
    <>
      <Tooltip placement="top" content={getThumbsUpTooltip({ isNegative, isPositive })}>
        <S.RateResponseWrapper>
          <ThumbsUpIcon onClick={() => handleRatingChange(FeedbackEnum.positive)} />
        </S.RateResponseWrapper>
      </Tooltip>
      {!!aiRatingResponseTooltip && isNegative ? (
        <FloatingTooltipCard content={aiRatingResponseTooltip} title="Your feedback:">
          <S.RateResponseWrapper scale={-1}>
            <ThumbsDownIcon onClick={() => handleRatingChange(FeedbackEnum.negative)} />
          </S.RateResponseWrapper>
        </FloatingTooltipCard>
      ) : (
        <Tooltip placement="top" content={getThumbsDownTooltip({ isNegative, isPositive })}>
          <S.RateResponseWrapper scale={-1}>
            <ThumbsDownIcon onClick={() => handleRatingChange(FeedbackEnum.negative)} />
          </S.RateResponseWrapper>
        </Tooltip>
      )}
    </>
  )
}
